import { TenantTypeEnum } from '_types/tenant-settings';
import { useAppSelector } from 'store/configureStore';

import { tenantSettingsTenantTypeSelector } from 'store/selectors/tenant-settings';

const useTenantType = (): TenantTypeEnum | undefined =>
  useAppSelector(tenantSettingsTenantTypeSelector);

export default useTenantType;
